import { FormattedMessage, useIntl } from "react-intl";

import { SidebarTabLink } from "common/sidebar";
import { SettingsPageWrapper, SettingsHeader } from "common/settingsv2/common";
import { useA11y } from "common/accessibility";
import { useDocumentTitles } from "util/document_title";

import ApiSettings from "./api_settings";

const TITLE = (
  <FormattedMessage id="d5b7c8d0-2ee5-45b2-b3eb-8e02af93aeef" defaultMessage="API Keys" />
);
export const API_KEYS_SETTINGS_ROOT_PREFIX = "api";

export const SettingsSidebarApiKeysLink = () => (
  <SidebarTabLink to={API_KEYS_SETTINGS_ROOT_PREFIX}>{TITLE}</SidebarTabLink>
);

export function ApiKeys() {
  useA11y().useDocumentEntitler({
    title: useIntl().formatMessage(useDocumentTitles().settingsApiKeys),
  });
  return (
    <SettingsPageWrapper>
      <SettingsHeader title={TITLE} tabs={[]} />
      <ApiSettings />
    </SettingsPageWrapper>
  );
}
